<div class="layout-sidebar" (click)="appMain.onMenuClick($event)">
    <a [routerLink]="['/']" class="logo">
      <!--   <img id="app-logo" class="logo-image" src="assets/layout/images/logo-white.svg" alt="diamond-ng"/> -->
        <span class="app-name">SIHC</span>
    </a>

    <div class="layout-menu-container">
        <ul class="layout-menu">
            <div class="p-input-icon-left search-wrapper sticky top-0 layout-sidebar-darkgray layout-sidebar" style="width: inherit; z-index: 1000;">
                <i class="pi pi-search"></i>
                <p-inputGroup>
                    <input type="text" [(ngModel)]="recherche" pInputText placeholder="Rechercher..." class="menu-search" (keyup)="rechercher()" />
                </p-inputGroup>
            </div>
            <ng-container *ngFor="let item of modelRecherche; let i = index;">
                <li app-menuitem *ngIf="!item.separator && item.visible" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator"></li>
            </ng-container>
        </ul>
    </div>
</div>
<div class="layout-sidebar-button" (click)="appMain.onMenuButtonClick($event)">
    <div class="layout-sidebar-button-content">
        <i [ngClass]="appMain.menuButtonIcon"></i>
    </div>
</div>